import { render } from "./Secoffer.vue?vue&type=template&id=938b8456"
import script from "./Secoffer.vue?vue&type=script&lang=js"
export * from "./Secoffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__